export default __webpack_public_path__ + "assets/logininfor.112c18ba.svg";